module.exports = __webpack_public_path__ + "svg/oeamtc-logo.svg";